import { Component, signal } from "@angular/core";
import { DsButtonModule, DsModalModule } from "@bmw-ds/components";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: 'pure-imprint-modal',
  imports: [DsModalModule, DsButtonModule, TranslateModule],
  templateUrl: './imprint.component.html',
})
export class ImprintComponent {
  modalIsOpen = signal(false);
}
